<template>
  <div class = "accordion-item" :class="separation">
    <input type = "checkbox" :id = "testId" :checked = "!testHide" @click = "emitShowText(index)">
    <label
      class = "accordion-item-title"
      :for = "testId"
      :class = "{'accordion-item-warning': testWarn, 'accordion-item-success': testOk, 'accordion-item-error': testError, 'smartphone': phone }"
    >
        <div class="accordion-item-title-text" :class="$mq">
          <aside class="accordion-item-title-text-icon" :class="$mq">
            <i :class="icon.type + ' '+ icon.img + ' ' + icon.type + '-' + icon.size + ' ' + icon.type + '-fw'" aria-hidden="true"/>
            {{ $t(`testBBB.tests[${index}]`) }}
          </aside>
          <BaseButton
            class="accordion-item-title-text-button"
            :class = "{ 'accordion-item-warning-button': testWarn, 'accordion-item-success-button': testOk, 'accordion-item-error-button': testError, 'button-smart': phone, 'button-computer': !phone }"
            @click = "emitIndividualTest(index)"
            :disabled = "testOn && !(testOk || testWarn || testError)"
          >
              {{ $t("testBBB.individual") }}
          </BaseButton>
        </div>
        <v-progress-circular
            indeterminate
            color="primary"
            v-if="testOn && !(testOk || testWarn || testError)"
        ></v-progress-circular>
        <div class="accordion-item-title-after" v-if="testOn">
          <i :class="arrow.type + ' ' + arrow.img + ' ' + arrow.type + '-' + arrow.size + 'x ' + arrow.type + '-fw'" />
        </div>
    </label>

    <div
        :id = "testId"
        class = "accordion-item-content"
        :class = "{ 'accordion-item-warning': testWarn, 'accordion-item-success': testOk, 'accordion-item-error': testError }"
        data-tab-content
    >
      <span v-if="testOk || testWarn || testError" class="accordion-item-content-title">
        <span v-if="testOk || testWarn || testError" v-html="$t('results.title')"/>
        <span v-if="testOk" v-html="$t('results.OK')"/>
        <span v-if="testWarn" v-html="$t('results.warning')"/>
        <span v-if="testError" v-html="$t('results.error')"/>
        <span v-if="testOn && !testOk && !testWarn && !testError" v-html="$t('testBBB.testRunning')"/>
        <br>
      </span>

      <span v-if="(testOk || testWarn) && testOn" v-html="$tc('results.messages', index, message.split('-'))"/>
      <span v-if="testOn && !(testWarn || testError) && nom == 'Connexion'">
        <!--p>IP Address : {{ speed.clientIp }}</p-->
        <!--<li>IP Address : {{ message.split('-')[1] }}</li>
        <li>Opérateur : {{ message.split('-')[2] }}</li>-->
        <div>{{ $t('results.speed.download', [speed.dlStatus]) }}
          <span v-if="!testOk">{{ $t('results.speed.completed', [speed.dlProgress]) }}</span>
        </div>
        <div> {{ $t('results.speed.upload', [speed.ulStatus]) }}
          <span v-if="!testOk"> {{ $t('results.speed.completed', [speed.ulProgress]) }}</span>
        </div>
        <div>{{ $t('results.speed.ping', [speed.ping]) }}</div><!--!! Ping -->
        <div>{{ $t('results.speed.jitter', [speed.jitter]) }}</div>
      </span>

      <span v-if="testError" v-html="$tc('errors.message', index, [message])"/>

      <span v-if="!testOn && testWarn" class="accordion-item-content-warning" v-html="$t('warnings.notBrowser')"/>
      <span v-if="testWarn && index == 0" class="accordion-item-content-warning" v-html="$t('warnings.browser')"/>
    </div>
  </div>
</template>

<script>
import BaseButton from "@/components/BaseButton"

export default {
  name: "testItem",
  components: {
    BaseButton,
  },
  props: {
    index: {
      type: Number,
      required: true,
    },
    nom: {
      type: String,
      required: true,
    },
    testId: {
      type: String,
      required: true,
    },
    icon: {
      type: Object,
      required: true,
    },
    arrow: {
      type: Object,
      required: true,
    },
    testOk: {
      type: Boolean,
      required: true,
    },
    testWarn: {
      type: Boolean,
      required: true,
    },
    testError: {
      type: Boolean,
      required: true,
    },
    testOn: {
      type: Boolean,
      required: true,
    },
    testHide: {
      type: Boolean,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    speed: {
      type: Object,
      required: true,
    },
  },

  methods: {
    emitIndividualTest(index) {
      this.$emit('run-individual-test', index)
    },

    emitShowText(index) {
      this.$emit('show-text', index)
    },
  },

  computed: {
    phone() {
      return this.$mq === 'smartphone'
    },

    separation() {
      if (this.index == 5) {
        return "final"
      }
      else {
        return "separation"
      }
    }
  }
}
</script>

<style lang="scss">
@import "../utilities/variables";

input {
  position: absolute;
  opacity: 0;
  z-index: -1;
}

.button-smart {
  max-width: 80%;
}

.button-computer {
  margin-left: auto;
}

.accordion-item.separation {
  border-top: 1px dotted;
  //border-bottom: 1px dotted;
  border-left: 1px dotted;
  border-right: 1px dotted;
  border-color: darken(#e8eff9,15%) !important;
}

.accordion-item-title-text-icon.smartphone {
  margin-bottom: 0.5em;
  text-align: center;
}

.accordion-item.final {
  border: 1px dotted;
  border-color: darken(#e8eff9,15%) !important;
}

.accordion-item-title-text.smartphone {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.accordion-item-title.smartphone {
  display: flex;
  align-items: center;
  justify-content: center;
}

.accordion-item {
  font-family: 'Unistra A';
  font-size: 20px;
  width: 100%;
  color: $text-color;
  overflow: hidden;
  &-title {
    display: flex;
    align-items: center;
    //place-items: start center;
    //justify-content: space-between;
    padding: 1em;
    background-color: $accordion-background-color;
    &-text {
      cursor: pointer;
      display: flex;
      align-items: center;
      width: 100%;
      /* Icon */
      &-icon {
        display: flex;
        align-items: center;
      }
      &-button {
        display: flex;
        padding: 0.1em 0.4em;
        text-align: center;
        align-items: center;
        background-color: lighten($button-color-blue, 30%);
        color: $text-color;
        border-color: transparent;
        border-radius: 0px;
        margin-right: 10px;
        //margin-left: auto;
        font-weight: normal;
        &:hover {
          background-color: lighten($button-color-blue, 20%);
          font-weight: bold;
        }
      }
    }
    &-after {
      transition: all .35s;
      margin-left: auto;
    }
    &:hover {
      background-color: darken($accordion-background-color, 10%);
      font-weight: bold;
    }
  }
  &-content {
    max-height: 0;
    padding: 0 1em;
    color: $text-color;
    background-color: $accordion-background-color;
    transition: all .35s;
    display:block;
    &-title {
      font-weight: bold;
    }
    &-warning {
      font-weight: bold;
    }
  }
  &-warning {
    background-color: $warning-background-color;
    &:hover {
      background-color: darken($warning-background-color, 10%);
    }
    &-button {
      background-color: darken($warning-background-color, 10%);
      &:hover {
        background-color: darken($warning-background-color, 20%);
      }
    }
  }
  &-error {
    background-color: $error-background-color;
    &:hover {
      background-color: darken($error-background-color, 10%);
    }
    &-button {
      background-color: darken($error-background-color, 10%);
      &:hover {
        background-color: darken($error-background-color, 20%);
      }
    }
  }
  &-success {
    background-color: $success-background-color;
    &:hover {
      background-color: darken($success-background-color, 10%);
    }
    &-button {
      background-color: darken($success-background-color, 10%);
      &:hover {
        background-color: darken($success-background-color, 20%);
      }
    }
  }
}

input:checked {
  + .accordion-item {
    &-title {
      background-color: darken($accordion-background-color, 5%);
      &:hover {
        background-color: darken($accordion-background-color, 10%);
      }
    }
    &-after {
      transform: rotate(45deg);
    }
    &-warning {
      background-color: darken($warning-background-color, 5%);
      &:hover {
        background-color: darken($warning-background-color, 10%);
      }
    }
    &-success {
      background-color: darken($success-background-color, 5%);
      &:hover {
        background-color: darken($success-background-color, 10%);
      }
    }
    &-error {
      background-color: darken($error-background-color, 5%);
      &:hover {
        background-color: darken($error-background-color, 10%);
      }
    }
  }
  ~ .accordion-item-content {
    max-height: 100vh;
    padding: 1em;
  }
}
</style>
